import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import ADMIN_API_URL from "../../../config/AdminApiUrl";

export const getEmailTemplateList = createAsyncThunk(
  "EmailTemplate/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${ADMIN_API_URL.EMAIL_TEMPLATE.SLUG}?${queryString}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createEmailTemplate = createAsyncThunk(
  "EmailTemplate/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${ADMIN_API_URL.EMAIL_TEMPLATE.SLUG}`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editEmailTemplate = createAsyncThunk(
  "EmailTemplate/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${ADMIN_API_URL.EMAIL_TEMPLATE.SLUG}`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteEmailTemplate = createAsyncThunk(
  "EmailTemplate/delete",
  async (Id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(
        `${ADMIN_API_URL.EMAIL_TEMPLATE.SLUG}/${Id}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getEmailTemplateDetails = createAsyncThunk(
  "EmailTemplateDetail/get",
  async (Id, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${ADMIN_API_URL.EMAIL_TEMPLATE.SLUG}/${Id}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const emailTemplateSlice = createSlice({
  name: "emailTemplate",
  initialState: {
    current_values: null,
    active_payload: null,
    email_template_list: [],
    email_template_details: {},
    total_records: 0,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEmailTemplateList.fulfilled, (state, action) => {
        state.email_template_list = action.payload.data.list;
        state.total_records = action.payload.data.totalRecords || 0;
      })
      .addCase(getEmailTemplateDetails.fulfilled, (state, action) => {
        state.email_template_details = action.payload;
      });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  emailTemplateSlice.actions;
export default emailTemplateSlice.reducer;
